import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import { ITINERARY_ACTIVE_OPTIONS } from '../../../config/constants';

const TicketActiveFilter = ({ onChangeFilter }) => (
  <ReactSelect
    isSearchable={false}
    isClearable
    menuPortalTarget={document.body}
    styles={{ menuPortal: base => ({ ...base, zIndex: 1000 }) }}
    onChange={option => onChangeFilter(option ? option.value : null)}
    menuPosition="fixed"
    menuPlacement="bottom"
    placeholder="Selecciona ..."
    options={ITINERARY_ACTIVE_OPTIONS}
  />
);

TicketActiveFilter.propTypes = {
  onChangeFilter: PropTypes.func.isRequired,
};

export default TicketActiveFilter;
